import { Asterisk } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="overflow-hidden border-y border-line bg-surface2/70 py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-8">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 whitespace-nowrap">
            <span
              className={`font-accent text-xl font-bold uppercase tracking-[0.12em] sm:text-2xl ${
                i % 2 === 0 ? "text-slate-300" : "text-outline"
              }`}
            >
              {item}
            </span>
            <Asterisk size={22} className="shrink-0 text-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}
